import React from "react";
import ReactDOM from "react-dom";
import moment from "moment-timezone";
import { Provider as ReduxProvider } from "react-redux";

import configureStore from "./store/store";
import "antd/dist/antd.less";
import * as serviceWorker from "./serviceWorker";
import "./locales/i18n";
import { MainRouter } from "./router/MainRouter";

require("typeface-open-sans");

const reduxStore = configureStore(window.REDUX_INITIAL_DATA);

// All dates will be handled as UTC and not by the local tz
moment.tz.setDefault("Etc/UTC");

ReactDOM.render(
  <ReduxProvider store={reduxStore}>
    <MainRouter />
  </ReduxProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
